// 全网黑料 —— 单页首页静态演示素材（仅作版式展示，均为虚构示例）

export interface TagKind {
  label: string;
  tone: 'primary' | 'accent' | 'secondary' | 'neutral';
}

// 顶部压顶更新条（无图，标题优先）
export const tickerItems: string[] = [
  '今晨新增 证据截图 12 组：某直播机构考勤流水与停播公告前后矛盾',
  '聊天记录 已核验 一批 2024 年前后录音视频与时间线吻合，实锤程度上调',
  '某综艺嘉宾 线下事件 出现第二目击者，文件材料口径与此前回应冲突',
  '录音视频 专区更新：3 段音频做声纹初检，节选与全文语境对照已整理',
  '辟谣通道 开启：被不实截图误伤的当事人可通过查证入口提交自证材料',
];

// 首屏焦点（大图卡片）
export const focusStory = {
  tag: '新 · 录音视频',
  title: '一段 12 分钟私下录音完整流出：直播间台前台词与人设话术判若两人',
  excerpt:
    '录音全程无剪辑做初步声纹比对，节选逐句转写成文字材料，时间线与团队此前的“断章取义”回应存在明显错位，相关证据截图已归档可随时调阅。',
  meta: '热度 862w · 更新于 12 分钟前',
  duration: '12:47',
  href: '#screenshot',
};

// 首屏右侧热度榜（石锤/热度）
export interface HeatItem {
  no: string;
  title: string;
  heat: string;
  trend: 'up' | 'flat' | 'new';
  diff: string;
  tag: string;
}
export const heatList: HeatItem[] = [
  { no: '01', title: '某顶流男艺人私联素人：聊天记录与礼物账单对得上', heat: '982w', trend: 'up', diff: '▲ 近期再发酵', tag: '聊天记录' },
  { no: '02', title: '翻车博主“老好人”人设崩盘，删除道歉视频前夜被扒旧档', heat: '917w', trend: 'up', diff: '▲ 昨夜涌入', tag: '证据截图' },
  { no: '03', title: '带货一姐 6 小时连麦被完整录音，压价话术与保真承诺打架', heat: '843w', trend: 'new', diff: '● 今日新增', tag: '录音视频' },
  { no: '04', title: '塌房男团成员集体合同纠纷，文件材料中的分账细则被逐条核对', heat: '766w', trend: 'flat', diff: '— 平稳上升', tag: '文件材料' },
  { no: '05', title: '网红情侣分手互撕，早期群聊记录成了最硬的时间线证据', heat: '702w', trend: 'up', diff: '▲ 聊天实锤', tag: '聊天记录' },
];

// 快速入口条（四大材料专区索引）
export interface EntryItem {
  key: string;
  name: string;
  desc: string;
  count: string;
  icon: string;
  theme: 'primary' | 'accent' | 'secondary' | 'dark';
}
export const quickEntries: EntryItem[] = [
  { key: 'screenshot', name: '证据截图', desc: '逐张核验、标注来源与修改痕迹的截图档案', count: '2,318 组', icon: 'ri-screenshot-2-line', theme: 'primary' },
  { key: 'chat', name: '聊天记录', desc: '按人物与事件归集的长文记录与群聊切片', count: '1,064 份', icon: 'ri-chat-history-line', theme: 'secondary' },
  { key: 'video', name: '录音视频', desc: '带时间轴节选与声纹初检的多媒体材料', count: '486 段', icon: 'ri-video-line', theme: 'accent' },
  { key: 'file', name: '文件材料', desc: '合同、流水、公告等可核对的一手文件', count: '351 件', icon: 'ri-file-list-3-line', theme: 'dark' },
];

// 证据截图 · 大图卡片流
export interface ShotItem {
  title: string;
  tag: string;
  count: string;
  time: string;
  heat: string;
  img: string;
}
export const shotGrid: ShotItem[] = [
  { title: '女星直播自证翻车？秒表截屏与平台在线时长对不上', tag: '实锤', count: '38 张', time: '更新 20 分钟前', heat: '821w', img: 'https://readdy.ai/api/search-image?query=Dark%20editorial%20forensic%20collage%20of%20blurred%20smartphone%20chat%20screen%20fragments%20and%20redacted%20text%20pages%20scattered%20on%20wooden%20desk%2C%20warm%20crimson%20and%20charcoal%20palette%2C%20dramatic%20side%20lighting%2C%20paper%20texture%2C%20investigation%20mood%2C%20cinematic%20high%20contrast%2C%20no%20identifiable%20faces&width=800&height=1066&seq=hb-shot-01&orientation=portrait' },
  { title: '男团经纪人深夜秒删贴文，清理前的网页截图被完整保留', tag: '石锤', count: '52 张', time: '更新 2 小时前', heat: '754w', img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20arrangement%20of%20glossy%20phone%20screens%20showing%20messaging%20bubbles%20and%20deleted%20post%20notices%2C%20layered%20translucent%20paper%2C%20deep%20red%20and%20warm%20neutral%20tones%2C%20moody%20studio%20light%2C%20fine%20grain%2C%20fashion%20editorial%20forensic%20vibe&width=800&height=1066&seq=hb-shot-02&orientation=portrait' },
  { title: '千万粉丝博主晒“原图”自证，EXIF 信息反而坐实后期修改', tag: '实锤', count: '27 张', time: '更新 5 小时前', heat: '698w', img: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20still%20life%20of%20stacked%20photographs%20and%20a%20magnifying%20glass%20over%20printed%20chat%20logs%2C%20crimson%20and%20umber%20color%20grade%2C%20soft%20shadow%2C%20vintage%20darkroom%20atmosphere%2C%20investigative%20newspaper%20layout%2C%20tactile%20texture&width=800&height=1066&seq=hb-shot-03&orientation=portrait' },
  { title: '综艺选秀投票截图遭逐帧比对，同一票池数据前后矛盾', tag: '新证据', count: '44 张', time: '更新 8 小时前', heat: '631w', img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20collage%20with%20voting%20number%20charts%20and%20camera%20surveillance%20grid%20over%20warm%20dark%20background%2C%20red%20accent%20highlights%2C%20documentary%20grain%2C%20layered%20transparency%2C%20modern%20data%20forensics%20aesthetic&width=800&height=1066&seq=hb-shot-04&orientation=portrait' },
  { title: '顶流演员剧组薪资外流，转账截图与纳税记录金额出入明显', tag: '实锤', count: '19 张', time: '更新 11 小时前', heat: '587w', img: 'https://readdy.ai/api/search-image?query=Dark%20editorial%20tableau%20of%20bank%20transfer%20slips%20and%20receipts%20fanned%20on%20dark%20leather%2C%20deep%20crimson%20lighting%2C%20ink%20seal%20stamp%2C%20money%20and%20contract%20forensic%20theme%2C%20fine%20film%20grain%2C%20no%20readable%20names&width=800&height=1066&seq=hb-shot-05&orientation=portrait' },
  { title: '美妆大V 探店回扣被扒：内部聊天截图里“给到多少”写得很直白', tag: '实锤', count: '61 张', time: '更新 14 小时前', heat: '543w', img: 'https://readdy.ai/api/search-image?query=Close%20up%20editorial%20abstract%20of%20cosmetic%20brand%20table%20with%20invoice%20papers%20and%20blurred%20phone%20conversation%2C%20warm%20amber%20and%20crimson%20palette%2C%20glossy%20product%20bokeh%2C%20investigative%20documentary%20light%2C%20premium%20texture&width=800&height=1066&seq=hb-shot-06&orientation=portrait' },
];

// 聊天记录 · 中密度文字卡片（标题优先）
export interface ChatItem {
  title: string;
  person: string;
  type: string;
  pages: string;
  time: string;
  heat: string;
}
export const chatArchive: ChatItem[] = [
  { title: '“先录个像再说”成笑话：当事人反问语音被一帧帧还原', person: '某音乐厂牌主理人', type: '微信 · 语音转文字', pages: '86 页', time: '今日', heat: '478w' },
  { title: '后援会高层内斗，群公告草稿与最终版相差一整段免责声明', person: '某限定团粉丝群', type: '群聊切片', pages: '142 页', time: '昨日', heat: '412w' },
  { title: '“这条别发群里”：制作人私聊意外透露出镜协议真实分成', person: '某综艺常驻嘉宾', type: '私聊记录', pages: '33 页', time: '3 天前', heat: '396w' },
  { title: '删好友前备份的对话框里，前任反复编辑撤回留下多个版本', person: '某塌房主播', type: 'QQ · 消息备份', pages: '58 页', time: '5 天前', heat: '351w' },
  { title: '节目组导演凌晨语音被公开，情绪化表达与成片口径两极', person: '某恋综节目组', type: '语音+文字', pages: '29 页', time: '1 周前', heat: '304w' },
  { title: '经纪团队内线爆料：解约艺人与公司的沟通记录被完整封存', person: '某女团成员', type: '长文记录', pages: '204 页', time: '1 周前', heat: '287w' },
  { title: '“数据是买的”亲口承认：运营对接聊天记录成最硬实锤', person: '某翻车主播团队', type: '微信 · 群聊', pages: '91 页', time: '2 周前', heat: '263w' },
];

// 录音视频 · 横版封面
export interface VideoItem {
  title: string;
  duration: string;
  tag: string;
  time: string;
  desc: string;
  img: string;
}
export const videoArchive: VideoItem[] = [
  { title: '6 小时连麦完整录音 · 压价话术专场', duration: '06:00:00', tag: '声纹初检完成', time: '今日', desc: '分段节选 18 处，逐句转写为文字材料供对照。', img: 'https://readdy.ai/api/search-image?query=Wide%20editorial%20shot%20of%20audio%20waveform%20on%20dark%20recording%20console%20with%20red%20peak%20meters%20and%20reel%20tape%2C%20crimson%20and%20charcoal%20tones%2C%20cinematic%20studio%20lighting%2C%20documentary%20forensic%20mood%2C%20fine%20grain%2C%20no%20identifiable%20people&width=800&height=450&seq=hb-video-01&orientation=landscape' },
  { title: '台下怒怼素人 40 秒原声 · 与台上道歉对照版', duration: '04:12', tag: '节选+对照', time: '昨日', desc: '原声降噪处理，同步制作与公开道歉逐句对照时间轴。', img: 'https://readdy.ai/api/search-image?query=Dark%20editorial%20close%20up%20of%20vintage%20microphone%20and%20recording%20red%20light%20in%20moody%20studio%2C%20audio%20equipment%20with%20dial%20meters%2C%20warm%20crimson%20backlight%2C%20grainy%20cinematic%20atmosphere%2C%20documentary%20evidence%20aesthetic&width=800&height=450&seq=hb-video-02&orientation=landscape' },
  { title: '饭局录音节选流出 · 涉及分成与后台交易', duration: '17:55', tag: '待复核', time: '2 天前', desc: '节选语境已标注，原始文件保留供声纹与剪辑复核。', img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20still%20life%20of%20a%20meeting%20table%20with%20cups%20and%20recorder%20blurred%20in%20foreground%2C%20crimson%20and%20umber%20grade%2C%20moody%20bar%20lighting%2C%20documentary%20surveillance%20mood%2C%20fine%20grain%2C%20tactile%20tabletop%20texture&width=800&height=450&seq=hb-video-03&orientation=landscape' },
];

// 文件材料 · 标题优先行列表
export interface FileItem {
  title: string;
  ext: string;
  size: string;
  tag: string;
  time: string;
}
export const fileArchive: FileItem[] = [
  { title: '解约艺人经纪合同 · 分账细则（PDF 扫描件）', ext: 'PDF', size: '24.6MB', tag: '已盖章', time: '今日' },
  { title: '直播机构考勤与停播申请流水表（Excel 脱敏版）', ext: 'XLS', size: '3.2MB', tag: '时间线比对', time: '昨日' },
  { title: '涉事公司回应函与原始通稿对照（Word）', ext: 'DOC', size: '1.8MB', tag: '口径核对', time: '3 天前' },
  { title: '剧组薪资发放明细（已打码）与纳税记录摘要', ext: 'ZIP', size: '41.3MB', tag: '金额复核', time: '1 周前' },
  { title: '某综艺现场内部排期与剪辑送审版本目录', ext: 'PDF', size: '12.9MB', tag: '版本追溯', time: '2 周前' },
];

// 合集索引（醒目分区，按事件归集）
export interface IndexTopic {
  key: string;
  title: string;
  items: string[];
  count: string;
  tone: 'primary' | 'accent' | 'secondary';
}
export const topicIndex: IndexTopic[] = [
  { key: '01', title: '直播塌房合集', items: ['带货一姐连麦翻车', '主播老好人设崩盘', '千万粉博主自证失败', '运营“买数据”群聊'], count: '86 篇材料', tone: 'primary' },
  { key: '02', title: '娱乐圈分手撕逼', items: ['网红情侣时间线', '艺人与前团队互撕', '综艺导演凌晨语音', '后援会内斗存档'], count: '52 篇材料', tone: 'secondary' },
  { key: '03', title: '选秀与综艺黑幕', items: ['投票池数据矛盾', '嘉宾分成协议', '排期送审版本', '舞台假唱实锤'], count: '47 篇材料', tone: 'accent' },
  { key: '04', title: '带货与佣金疑云', items: ['探店回扣聊天', '内部分成细则', '礼赠清单外流', '压价话术录音'], count: '39 篇材料', tone: 'secondary' },
];

// 更新日志 · 查证进度/辟谣
export interface LogItem {
  time: string;
  type: string;
  tone: 'accent' | 'secondary' | 'primary' | 'neutral';
  title: string;
  desc: string;
}
export const timelineLog: LogItem[] = [
  { time: '2026-09-06 09:40', type: '实锤更新', tone: 'primary', title: '带货一姐 6 小时连麦录音完成声纹初检', desc: '节选语境与转写文字材料已整理入档，比对结论与自辩回应相悖。' },
  { time: '2026-09-05 22:10', type: '新增证据', tone: 'accent', title: '顶流男艺人私联素人聊天记录增至 38 页', desc: '新增时间线截图一组，与早期公开行程存在重叠，已标注待进一步核验。' },
  { time: '2026-09-05 15:30', type: '辟谣标注', tone: 'secondary', title: '某博主自证贴被判不成立', desc: '原图 EXIF 信息经比对确认存在后期改动，撤销其“辟谣”结论，保留原始截图。' },
  { time: '2026-09-04 18:05', type: '档案归档', tone: 'neutral', title: '翻车主播群聊记录完成逐段标注', desc: '91 页微信记录已脱敏归档，“数据是买的”关键句保留原始语境说明。' },
  { time: '2026-09-03 11:20', type: '实锤更新', tone: 'primary', title: '恋综导演录音与成片口径差异获佐证', desc: '新增成片送审版本对照，时间线与口头表述差异进一步坐实。' },
];

// 页脚站点分组（运营壳）
export const footerGroups: { title: string; links: string[] }[] = [
  { title: '材料归档', links: ['证据截图', '聊天记录', '录音视频', '文件材料', '合集索引'] },
  { title: '查证工具', links: ['人物检索', '事件时间线', '声纹初检', '截图验真', '辟谣台账'] },
  { title: '关于本站', links: ['查证规范', '投稿说明', '免责声明', '隐私与纠错', '联系方式'] },
];